import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import SideNavigation from 'sharedComponents/ProductStream/SideNavigation/SideNavigation'
import {
  useLayoutStore,
  useSearchPageStore,
  useUrlManagerStore,
  useUserStore,
} from 'store/context'

export const SearchPageSideNavigation: FC = () => {
  const urlManager = useUrlManagerStore()
  const searchPageStore = useSearchPageStore()
  const layoutStore = useLayoutStore()
  const { gender } = useUserStore()
  const rootCategoryLoaded = useObserver(
    () => layoutStore.categoriesLoadedForGender[gender],
  )
  const rootCategoryIds = useRootCategoryIds(
    rootCategoryLoaded,
    searchPageStore.category.rootId,
  )
  const pathName = useObserver(() => urlManager.pathname)
  return (
    <SideNavigation
      basePath={pathName}
      rootIds={rootCategoryIds}
      excludeEmptyCategories
      excludeTop100
    />
  )
}

const useRootCategoryIds = (
  rootCategoryLoaded: boolean,
  categoryRootId: string,
) => {
  const service = useService()
  const rootCategory = service.categories.getById(categoryRootId)

  const rootCategoryIds: string[] =
    rootCategoryLoaded && rootCategory ? rootCategory.childrenIds : []

  return rootCategoryIds
}
